import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { getCreatedToastMessage, getErrorToastMessage } from '@/libs/api'
import { QUERY_KEYS } from '@/libs/constants'
import type { CreateOvertimePayload } from '@/libs/interfaces'
import { overtimesApi } from '@/services/api'

export function useOvertimeCreate() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: ({
      employeeID,
      storeID,
      payload,
    }: {
      employeeID: string
      storeID: string
      payload: CreateOvertimePayload
    }) => overtimesApi.create(employeeID, storeID, payload),
    onSuccess: (result) => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.overtimes.all,
      })
      toast.success(getCreatedToastMessage(result, t('overtime.created')))
    },
    onError: (error) => {
      toast.error(getErrorToastMessage(error, t('common.error')))
    },
  })
}
